import { IConnectionState } from '../../interfaces';
import { injectable } from 'inversify';
import {
    IStateOfKondorBlotterConnectionService,
} from './state-of-kondor-blotter-connection.interface';
import { NEVER, Observable } from 'rxjs';

@injectable()
export class StateOfKondorBlotterConnectionMock implements IStateOfKondorBlotterConnectionService {
    asObservable(): Observable<IConnectionState> {
        return NEVER;
    }
}
